export default __webpack_public_path__ + "static/media/europeaRouletteTimer.1af5ece8.svg";